import React from 'react';
import { Navigate } from 'react-router';
import Base from '../../Base';

export default class CurriculumSession extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            curriculumId: props.CurriculumId,
            data: null,
            loading: true,
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/curriculumsession/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.durationMinutes)) this.state.data.record.durationMinutes = 0;
        if (this.isBlank(this.state.data.record.sessionNumber)) this.state.data.record.sessionNumber = 0;

        this.httpPost("api/v1/curriculumsession/save", {
            id: this.state.id,
            companyId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            curriculumId: this.state.data.record.curriculumId,
            content: this.state.data.record.content,
            objectives: this.state.data.record.objectives,
            durationMinutes: this.state.data.record.durationMinutes,
            sessionNumber: this.state.data.record.sessionNumber,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش جلسه آموزشی" : "افزودن جلسه آموزشی جدید"}
                            </h4>
                        </div>
                        {this.renderBody()}
                    </div>
                </div>
            </div>
        </div>
    }
    renderBody() {
        return [
            <div className="modal-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label className="form-label">عنوان</label>
                                <div className="form-control-wrap">
                                    <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">شماره</label>
                                <div className="form-control-wrap">
                                    <input autoComplete="off" defaultValue={this.state.data.record.sessionNumber} onChange={e => this.state.data.record.sessionNumber = parseInt(e.target.value)} type="text" className="form-input" maxLength="100" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">مدت(دقیقه)</label>
                                <div className="form-control-wrap">
                                    <input autoComplete="off" defaultValue={this.state.data.record.durationMinutes} onChange={e => this.state.data.record.durationMinutes = parseInt(e.target.value)} type="text" className="form-input" maxLength="100" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="form-label">اهداف</label>
                                <div className="form-control-wrap">
                                    <textarea className="form-input" type="text" defaultValue={this.state.data.record.objectives} onChange={e => this.state.data.record.objectives = e.target.value}></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="form-label">محتوا</label>
                                <div className="form-control-wrap">
                                    <textarea className="form-input" type="text" defaultValue={this.state.data.record.content} onChange={e => this.state.data.record.content = e.target.value}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div className="modal-footer">
                <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                    <span className="shortcut">F4 - </span> ذخیره
                </button>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline ? this.renderBody() : this.renderForm()
            ];

        return contents;
    }
}